import New from './ChangesManagementNew'
import Edit from './ChangesManagementEdit'
import Main from './ChangesManagementMain'
import Show from './ChangesManagementShow'

export default {
  Edit,
  New,
  Main,
  Show,
}
